import { render, staticRenderFns } from "./AverageItemPerOrderPage.vue?vue&type=template&id=56601de7&scoped=true&"
import script from "./AverageItemPerOrderPage.vue?vue&type=script&lang=js&"
export * from "./AverageItemPerOrderPage.vue?vue&type=script&lang=js&"
import style0 from "./AverageItemPerOrderPage.vue?vue&type=style&index=0&id=56601de7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56601de7",
  null
  
)

export default component.exports